import { render, staticRenderFns } from "./dept.vue?vue&type=template&id=5e8d6af6&scoped=true&"
import script from "./dept.vue?vue&type=script&lang=js&"
export * from "./dept.vue?vue&type=script&lang=js&"
import style0 from "./dept.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dept.vue?vue&type=style&index=1&id=5e8d6af6&scoped=true&lang=css&"
import style2 from "./dept.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8d6af6",
  null
  
)

export default component.exports